/**
 * Wize Mobile API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface AccountMobile { 
    id?: string;
    identification?: string;
    description?: string;
    shortDescription?: string;
    currencyId?: string;
    currentBalance?: number;
    ibanIdentification?: string;
    formattedIbanIdentification?: string;
    authorizedPaymentsAndTransfers?: boolean;
    authorizedStockExchangeOrders?: boolean;
    typeValue?: AccountMobile.TypeValueEnum;
    accountTypeId?: string;
    portfolioId?: string;
}
export namespace AccountMobile {
    export const TypeValueEnum = {
        CURRENT_ACCOUNT: 'CURRENT_ACCOUNT',
        GUARANTEE_ACCOUNT: 'GUARANTEE_ACCOUNT',
        MONEY_MARKET_ACCOUNT: 'MONEY_MARKET_ACCOUNT',
        COLLATERAL_ACCOUNT: 'COLLATERAL_ACCOUNT',
        PROVISIONAL_ACCOUNT: 'PROVISIONAL_ACCOUNT',
        UNPAID_ACCOUNT: 'UNPAID_ACCOUNT',
        NOSTRO_FIDUCIARY: 'NOSTRO_FIDUCIARY',
        NOSTRO_SECURITY: 'NOSTRO_SECURITY',
        ISS_GUAR_CC_BEN: 'ISS_GUAR_CC_BEN',
        ISS_GUAR_CC_ORD: 'ISS_GUAR_CC_ORD',
        ISS_GUAR_DI_BEN: 'ISS_GUAR_DI_BEN',
        ISS_GUAR_DI_ORD: 'ISS_GUAR_DI_ORD',
        REC_GUAR_DI_BEN: 'REC_GUAR_DI_BEN',
        REC_GUAR_DI_ORD: 'REC_GUAR_DI_ORD',
        LETTER_OF_CREDIT: 'LETTER_OF_CREDIT',
        ORDER_ACCOUNT: 'ORDER_ACCOUNT',
        CREDIT_CARD_LIMIT: 'CREDIT_CARD_LIMIT',
        MORTGAGE_ACCOUNT: 'MORTGAGE_ACCOUNT',
        MARGIN_ACCOUNT: 'MARGIN_ACCOUNT',
        NOT_CURRENT_ACCOUNT: 'NOT_CURRENT_ACCOUNT',
        CORRESPONDANT_ACCOUNT: 'CORRESPONDANT_ACCOUNT',
        ACCRUED_INTEREST_ACCOUNT: 'ACCRUED_INTEREST_ACCOUNT',
        INCOME_TO_RECEIVE_ACCOUNT: 'INCOME_TO_RECEIVE_ACCOUNT',
        DERIVATIVE_ACCOUNT: 'DERIVATIVE_ACCOUNT'
    } as const;
    export type TypeValueEnum = typeof TypeValueEnum[keyof typeof TypeValueEnum];
}


